import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IPagination, ISearchResult, ICitySimple } from '../models';
import { SearchEndpoint } from '../endpoints/search';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Params } from '@angular/router';
/**
 * ### **SearchService**
 *
 * Un Servicio en Angular es el mecanismo para compartir funcionalidad entre componentes, en este caso se encarga de
 * compartir las funciones para las busquedas, estas hacen diferentes peticiones o llamados a distintos API's que
 * genera el backend.
 */
@Injectable({
  providedIn: 'root',
})
export class Search {
  private readonly http = inject(HttpClient);

  /**  Variable de tipo BehaviorSubject(observable) que maneja la estructura de las ciudades*/
  citiesSubject = new BehaviorSubject<ICitySimple[]>([]);
  /**  Variable de tipo BehaviorSubject(observable) que maneja la estructura de los geomarcadores seleccionados*/
  markerSelectedSubject = new BehaviorSubject<ISearchResult | null>(null);

  /** @ignore**/
  constructor() {}

  /**
   * Fución encargada de realizar una petición get al api de busquedas aplicando los filtros elegidos por el usuario,
   * y asi obtener la lista de los geomarcadores deseados.
   * @param queryParams Parametro que recibe el filtro.
   */
  search(queryParams: string): Observable<IPagination<ISearchResult[]>> {
    return this.http.get<IPagination<ISearchResult[]>>(
      `${SearchEndpoint.search}${queryParams ? queryParams : ''}`,
    );
  }

  /**
   * Fución encargada de realizar una petición get al api de busquedas para obtener una lista de geomarcadores aleatorios.
   * @returns Retorna una lista de geomarcadores aleatorios.
   */
  searchRandom(params: Params): Observable<IPagination<ISearchResult[]>> {
    return this.http.get<IPagination<ISearchResult[]>>(`${SearchEndpoint.searchRandom}`, {
      params,
    });
  }

  /**
   * Fución encargada de realizar una petición get al api de busquedas aplicando los filtros elegidos por el usuario,
   * y asi obtener la lista de los geomarcadores que serán renderizados en el mapa deseados.
   * @param queryParams Parametro que recibe el filtro.
   */
  searchMap(queryParams: string): Observable<Array<ISearchResult>> {
    const qr = queryParams ? queryParams : '';
    return this.http.get<Array<ISearchResult>>(`${SearchEndpoint.searchMap}${qr}`);
  }
}
